<template>
  <div>
    <slot :isCompleted="isCompleted" :isSigned="isSigned"> </slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('mall', ['providersObj']),
    ...mapState('contract', ['contracts']),
    availableContracts() {
      // 서비스 가능한 mall이 포함되어 있는 contracts만 분류
      if (Object.keys(this.providersObj).length === 0) {
        return []
      }
      const result = this.contracts.filter((v) => {
        return v.mallProviderCode !== null && this.providersObj[v.mallProviderCode].isAvailable
      })
      return result
    },
    completedContracts() {
      // availableContracts의 상태가 completed인 경우
      return this.availableContracts.filter((v) => v.status === 'completed')
    },
    signedContracts() {
      // availableContracts의 상태가 signed인 경우
      return this.availableContracts.filter((v) => v.status === 'signed')
    },
    isCompleted() {
      // 서비스 약정서의 상태가 completed이고 completedContracts의 개수가 1개 이상일 때
      return this.completedContracts.length > 0 || this.signedContracts.length > 0
    },
    isSigned() {
      // 서비스 약정서의 상태가 signed이고 compltedContracts가 하나도 없고, signedContracts가 1개 이상일 때
      console.log(this.completedContracts.length === 0 && this.signedContracts.length > 0)
      return this.completedContracts.length === 0 && this.signedContracts.length > 0
    },
  },
}
</script>
